// Shared clause text — the single source of truth for what each toggle in
// LeaseWizard's "Clauses" step actually puts in the lease. Used by the plain-text
// document (buildLeaseText), the printable HTML (buildPrintHtml, via esc()), and
// the live "preview text" toggle in the wizard itself, so all three can never
// drift out of sync with each other.

export function getPetPolicyText(petPolicy, depositAmount) {
  const deposit = depositAmount ? `$${Number(depositAmount).toLocaleString()}` : "[Amount]";
  return {
    no_pets:     "No pets of any kind are permitted on the premises without prior written consent from Landlord.",
    cats_only:   "Cats (domestic, indoor) are permitted with prior written approval from Landlord. Tenant is liable for all pet-related damage.",
    dogs_deposit:`Dogs are permitted with Landlord's prior written approval and a non-refundable pet deposit of ${deposit}. Tenant is liable for all pet-related damage.`,
    all_deposit: `Pets are permitted with Landlord's prior written approval and a non-refundable pet deposit of ${deposit}. Tenant is liable for all pet-related damage.`,
  }[petPolicy] || "No pets permitted.";
}

export function getLateFeeText(lateFeePolicy, lateFeeType, lateFeeAmount) {
  if (!lateFeePolicy) return null;
  const lateFeeStr = lateFeeType === "flat"
    ? `a flat fee of ${lateFeeAmount ? `$${Number(lateFeeAmount).toLocaleString()}` : "[Amount]"}`
    : `a fee equal to five percent (5%) of the monthly rent`;
  return `If rent is not received within five (5) calendar days after the due date, Tenant shall pay ${lateFeeStr}. Late fees are in addition to the rent and do not waive Landlord's right to declare a default.`;
}

export function getMaintenanceText() {
  return "Tenant shall keep the premises clean and notify Landlord promptly of any needed repairs. Tenant is responsible for minor repairs costing less than $50. Landlord shall maintain the premises in compliance with applicable housing codes and perform all major structural and mechanical repairs.";
}

export function getGuestText() {
  return "Guests may not occupy the premises for more than fourteen (14) consecutive days in any sixty (60) day period without Landlord's prior written approval. Unauthorized long-term guests will be treated as additional occupants and may constitute a material breach of this Agreement.";
}

export function getNoSmokingText() {
  return "Smoking of any substance — including tobacco, cannabis, and electronic cigarettes — is strictly prohibited inside the premises, in all common areas, and within twenty-five (25) feet of any building entrance. Violations may result in cleaning charges and/or lease termination.";
}
